import {ofetch} from 'ofetch';
import {useSessionStore} from "~/stores/session";

const AUTH_HEADER = "X-Auth-Token";

let delay = (t) => {
    return new Promise((resolve) => {
        setTimeout(resolve, t);
    });
};

class Network {

    constructor() {
        this.store = null;
        this.http = null;
    }

    /**
     * Called from app.vue on creation, sets the store reference and creates the ohMyFetch instance
     */
    configure(store) {
        this.store = store;
        this.http = this.createOFetchInstance();
    }

    createOFetchInstance() {
        /*
        http.interceptors.response.use(
            (response) => {
                let jwt = response.headers[AUTH_HEADER.toLowerCase()];
                if (jwt) {
                    logger.debug("Refreshing JWT...");
                    this.store.dispatch("session/refreshJwt", jwt);
                } else {
                    logger.debug("No JWT in response!");
                }
                return Promise.resolve(response);
            },
            (error) => {
                logger.warn("AJAX call resulted in an error response.");
                logger.warn(error);
                if (error.response.status === 401) {
                    // unauthorized
                    this.store.dispatch("session/logout");
                    this.router.push("/login");
                }
                if (error.response.status === 403) {
                    // forbidden
                    this.router.push("/");
                }
                return Promise.reject(error);
            }
        );
        */
        const self = this;
        return ofetch.create({
            baseURL: "/api",
            async onResponse({request, response, options}) {
                let jwt = response.headers.get(AUTH_HEADER.toLowerCase());
                if (jwt) {
                    self.store.refreshJwt(jwt);
                }
                //console.log('[fetch response]', request, response.status, response.body, response.headers)
            },
            async onRequest({request, options}) {
                options.headers = options.headers || {};
                options.headers['Accept'] = "application/json";
                if(options.headers['Content-Type'] && options.headers['Content-Type'] === 'multipart/form-data') {
                    delete options.headers['Content-Type'];
                }
                else {
                    options.headers['Content-Type'] = "application/json";
                }

                let jwt = self.store.jwt;
                if (!jwt || jwt === "") {
                    // No JWT to use!
                }
                else {
                    options.headers[AUTH_HEADER] = self.store.jwt;
                }
            },

            async onRequestError({request, options, error}) {
                console.log('[fetch request error]', request, error);
            },
            async onResponseError({request, response, options}) {
                if (response.status === 401) {
                    // unauthorized
                    const sessionStore = useSessionStore();
                    sessionStore.logout();
                }
                else if (response.status === 403) {
                    // forbidden
                    const sessionStore = useSessionStore();
                    sessionStore.logout();
                }
                console.log('[fetch response error]', request, response.status, response.body);
            },
        });
    }

    async connection() {
        if (this.store.isAuthReady()) return this.http;
        console.log("No JWT detected, establishing an interval to wait for it...");
        let rounds = 0;
        while (rounds < 6 && !this.store.isAuthReady()) {
            console.log("Waiting for session establishment...");
            await delay(500);
            rounds++;
        }
        return this.http;
    }
}

export default new Network();
